import React from 'react';
import {
  useLocation,
  useHistory,
  useRouteMatch,
}            from 'react-router-dom';

export function useRouter() {
  const location = useLocation();
  const history  = useHistory();
  const match    = useRouteMatch();

  return React.useMemo(() => {
    return {
      match,
      location,
      history,
    };
  }, [match, location, history]);
}